module.exports = __webpack_public_path__ + "static/img/pro3_tab7.3e3e00e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro3_tab7.jpg
// module id = EIyo
// module chunks = 171